customElements.whenDefined('product-card-info').then(() => {
  const CardInfo = customElements.get('product-card-info');
  const original = CardInfo.prototype.updateSourceFromDestination;
  CardInfo.prototype.updateSourceFromDestination = function(parsedHTML, id) {
    const card = this.closest('.wm-enhanced-card');
    if (card && id === 'ProductGallery' && card.dataset.wmHover === 'hide') return;
    return original.call(this, parsedHTML, id);
  };
});

customElements.whenDefined('product-bundle-picker').then(() => {
  const Picker = customElements.get('product-bundle-picker');
  const updateImage = Picker.prototype.updateImage;
  Picker.prototype.updateImage = function(src, srcset) {
    if (this.classList.contains('wm-enhanced-card') && this.dataset.wmHover === 'hide') return;
    return updateImage.call(this, src, srcset);
  };
});
